module.exports = __webpack_public_path__ + "static/media/caret-up-dark.06c4695e.svg";